import { render } from "./pop-up-message.vue?vue&type=template&id=69c76525&scoped=true"
import script from "./pop-up-message.vue?vue&type=script&lang=js"
export * from "./pop-up-message.vue?vue&type=script&lang=js"

import "./pop-up-message.vue?vue&type=style&index=0&id=69c76525&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69c76525"]])

export default __exports__